import { Navigate } from 'react-router';

import { selectIncludeCostApproach } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export const CostApproachGuard = ({ children }: React.PropsWithChildren) => {
  const includeCostApproach = useAppSelector(selectIncludeCostApproach);

  if (!includeCostApproach) {
    return <Navigate to="/" />;
  }

  return children;
};
